module.exports = __webpack_public_path__ + "media/images/icons/form_musician_step_3-1b82d77489f3e29a5fb1a9a215192902.svg";